module.exports = __webpack_public_path__ + "img/png.970bfad6.svg";